import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';

import LeviaLearnMoreArticle from '../../../components/Levia/LeviaLearnMore/LeviaLearnMoreArticle';
import {PopupMobileFullPage} from '../../../components/Popup';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import modalService from '../../../services/modalService';
import storageService from '../../../services/storage/storageService';
import {selectLeviaRelatedTargetSerialNumber} from '../../../state/selectors/iotDevice';
import elementsTesIds from '../../../test/consts/elementsTesIds';

const LeviaLearnMorePopup = ({modalType, isCheckCompatibility}) => {
    const localizedStrings = getLocalizedStrings();
    const serialNumber = useSelector(selectLeviaRelatedTargetSerialNumber);
    const onClose = () => modalService.hideModal(modalType);

    useEffect(() => {
        const dataToStore = isCheckCompatibility
            ? {serialNumber, wasShownCheckCompatibility: true}
            : {serialNumber, wasShownLearnMorePopup: true};

        storageService.setLeviaPopupsDataToLocalStorageBySerialNumber(dataToStore);
    }, [serialNumber]);

    return (
        <PopupMobileFullPage
            contentLabel={localizedStrings[localizationKeys.LEVIA_LEARN_MORE_TITLE]}
            isCloseVisible
            onClose={onClose}
            closeButtonTestId={elementsTesIds.DEVICE_SETTINGS_BTN_CLOSE}
            closeButtonAriaLabel={localizedStrings[localizationKeys.LEVIA_LEARN_MORE_CLOSE_BUTTON_ARIA_LABEL]}
        >
            <div className='flex justify-center px-8 pb-8 pt-18 md:p-0'>
                <LeviaLearnMoreArticle onCancel={onClose} isCheckCompatibility={isCheckCompatibility} />
            </div>
        </PopupMobileFullPage>
    );
};

export default LeviaLearnMorePopup;
